module.exports = __webpack_public_path__ + "static/media/search.b4dea23b.svg";